import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { CREDIT_REQUEST_ROUTES } from './routes';
import { CreditRequestFormScreen } from '@/screens/credit-request-form-screen';
import { CreditRequestStackParams } from './types';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';

const Stack = createStackNavigator<CreditRequestStackParams>();

export const CreditRequestStack: React.FC = () => {
  const options = useDefaultStackScreenOptions();
  return (
    <Stack.Navigator screenOptions={options}>
      <Stack.Screen
        component={CreditRequestFormScreen}
        name={CREDIT_REQUEST_ROUTES.Base}
      />
    </Stack.Navigator>
  );
};
